export default "__VITE_ASSET__04a7d54c__"